import { IStore } from 'core/rootReducer'

export const getNotificationState = (state: IStore) => state.notification
